define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");

    var KEYS = {
        ID: "id",
        NAME: "name",
        TYPE: "type",
        LOGO_URI: "logoUri",
        SHORT_DESCRIPTION: "shortDescription",
        FULL_DESCRIPTION: "fullDescription",
        ENABLED: "enabled",
        CONFIGURABLE: "configurable",
        CONFIGURED: "configured",
        PATH: "path"
    };

    var ConversationSourcesGalleryModel = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        ConversationSourcesGalleryModel = BaseModel.extend({
            name: "ConversationSourcesGalleryModel",
            KEYS: KEYS,
            defaults: {
                name: "",
                logoUri: "",
                shortDescription: "",
                fullDescription: "",
                configurable: true,
                configured: false,
                enabled: false,
                path: null
            },

            getName: function() {
                return this.get(KEYS.NAME);
            },

            getLogoUri: function() {
                return this.get(KEYS.LOGO_URI);
            },

            getShortDescription: function() {
                return this.get(KEYS.SHORT_DESCRIPTION);
            },

            getFullDescription: function() {
                return this.get(KEYS.FULL_DESCRIPTION);
            },

            isConfigured: function() {
                return this.get(KEYS.CONFIGURED);
            },

            isEnabled: function() {
                return this.get(KEYS.ENABLED);
            },

            isConfigurable: function() {
                return this.get(KEYS.CONFIGURABLE);
            },

            setConfigured: function(configured){
                this.set(KEYS.CONFIGURED, configured);
            },

            setEnabled: function(enabled){
                this.set(KEYS.ENABLED, enabled);
            },

            setPath: function(path){
                this.set(KEYS.PATH, path);
            },

            getPath: function() {
                return this.get(KEYS.PATH);
            },

            isEditable: function() {
                return !(this.isConfigurable() && !this.isConfigured());
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    ConversationSourcesGalleryModel.KEYS = KEYS;

    return ConversationSourcesGalleryModel;
});

